import React from "react";

const VIEWPORTS = {
  mobile: { label: "Mobil", width: 375 },
  tablet: { label: "Nettbrett", width: 768 },
  desktop: { label: "Desktop", width: 1280 },
  full: { label: "Full bredde", width: null }
};

export const viewportOptions = Object.entries(VIEWPORTS).map(([value, item]) => ({
  value,
  label: item.label
}));

const ResponsivePreview = ({ viewport = "desktop", children }) => {
  const selected = VIEWPORTS[viewport] ?? VIEWPORTS.desktop;
  const width = selected.width;

  return (
    <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
      <div className="mb-2 text-xs font-medium text-slate-500">
        Viewport: {selected.label} {width ? `(${width}px)` : ""}
      </div>
      <div className="overflow-auto">
        <div
          className="min-h-[220px] rounded-lg border border-slate-200 bg-white p-4"
          style={{ width: width ? `${width}px` : "100%" }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default ResponsivePreview;
